enum ActionEnum {
	Create = "create",
	Update = "update",
}

export default ActionEnum;
